<template>
    <div>
        <center-header />
        <!-- 商品信息展示 -->
        <div class="container">
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item @click.native="$router.go(-1)">商品管理</el-breadcrumb-item>
                    <el-breadcrumb-item>查看评价</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="evaluate-list">
                <div class="product-info">
                    <div class="product-image">
                        <img :src="productInfo.thumb" alt="商品图片">
                    </div>
                    <div class="product-details">
                        <div class="product-name">{{ productInfo.name }}</div>
                        <div class="product-price">
                            <span class="price-value">￥{{ productInfo.shop_price }}</span>
                        </div>
                    </div>
                </div>
                <!-- 评价列表 -->
                <div class="comments-header">
                    <span class="comments-title">用户评价 ({{ total }})</span>
                </div>
                <div class="comment-item" v-for="(item, index) in evaluateList" :key="index">
                    <div class="comment-header">
                        <div class="user-info">
                            <div class="user-avatar">
                                <img :src="item.avatar" alt="用户头像">
                            </div>
                            <div class="user-name">{{ item.nickname }}</div>
                        </div>
                        <div class="comment-time">{{ item.create_time }}</div>
                    </div>
                    <div class="comment-content">
                        <p>{{ item.content }}</p>
                    </div>
                    <div class="comment-images" v-if="item.thumb && item.thumb.length > 0">
                        <div class="comment-image-item" v-for="(ele, index1) in item.thumb" :key="index1">
                            <el-image :src="ele" :preview-src-list="item.thumb"></el-image>
                        </div>
                    </div>
                    <div class="comment-rating">
                        <div class="comment-spec-stars">评价星级：</div>
                        <el-rate disabled v-model="item.star" :max="5"></el-rate>
                    </div>
                    <!-- 平台回复 -->
                    <!-- <div class="platform-reply" v-if="item.reply">
                        <div class="reply-content">{{ item.reply }}</div>
                        <div class="reply-time">{{ item.reply_time }}</div>
                    </div> -->
                </div>
                <!-- 空状态 -->
                <div class="empty-state" v-if="evaluateList.length === 0">
                    <el-empty description="暂无评价数据"></el-empty>
                </div>
            </div>
            <!-- 分页控件 -->
            <div class="pagination">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currentPage"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
// 导入头部和底部组件
import CenterHeader from '../shopCenter/components/CenterHeader.vue'
import Footer from '../../components/Footer.vue'
export default {
    name: 'ViewEvaluate',
    components: {
        CenterHeader,
        Footer
    },
    data() {
        return {
            // 商品信息
            productInfo: {},
            // 评价列表
            evaluateList: [],
            // 分页数据
            currentPage: 1,
            pageSize: 10,
            total: 0,
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    mounted() {
        // 获取路由参数
        this.goods_id = this.$route.query.goods_id;
        this.partner_id = this.$route.query.partner_id;
        this.getProductInfo();
        this.getEvaluateList();
    },
    methods: {
        // 返回上一页
        goBack() {
            this.$emit('goToComponent', 'ProductList');
        },
        // 获取商品信息
        getProductInfo() {
            this.$api.getProductInfo({
                goods_id: this.goods_id,
                partner_id: this.partner_id
            }).then(res => {
                this.productInfo = res;
            }).catch(err => {
                this.$message.error(err);
            });
        },

        // 获取评价列表
        getEvaluateList() {
            this.$api.commentList({
                goods_id: this.goods_id,
                page: this.currentPage,
                page_size: this.pageSize
            }).then(res => {
                this.evaluateList = res.data;
                this.total = res.total;
            }).catch(err => {
                this.$message.error(err);
            });
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getEvaluateList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getEvaluateList();
        },
    }
}
</script>

<style scoped>
/* 面包屑样式 */
.breadcrumb {
    margin: 20px 0;
}

.shop-evaluate-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    padding: 20px 0;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* 商品信息展示 */
.product-info {
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
}

.product-image {
    width: 120px;
    height: 120px;
    margin-right: 20px;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
}

.product-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.product-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    text-align: left;
}

.product-price {
    display: flex;
    align-items: center;
}

.price-label {
    font-size: 14px;
    color: #666;
    margin-right: 10px;
}

.price-value {
    font-size: 18px;
    font-weight: 600;
    color: #ff6b6b;
}

/* 筛选区域 */
.search-section {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-form {
    display: flex;
    align-items: center;
    gap: 15px;
}

/* 评价列表 */
.evaluate-list {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    margin-bottom: 20px;
}

.comments-header {
    margin-top: 20px;
    text-align: left;
}

.comments-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.comment-item {
    padding: 20px 0;
    border-bottom: 1px solid #e8e8e8;
    text-align: left;
}

.comment-item:last-child {
    border-bottom: none;
}

.comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.user-name {
    font-size: 14px;
    color: #333;
}

.comment-time {
    font-size: 12px;
    color: #999;
}

.comment-content {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 10px;
}

.comment-images {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.comment-image-item {
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 4px;
}

.comment-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.comment-rating {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.comment-spec-stars {
    font-size: 12px;
    color: #999;
    margin-right: 5px;
}

/* 平台回复 */
.platform-reply {
    background-color: #f5f7fa;
    padding: 10px 15px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.reply-content {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 5px;
}

.reply-time {
    font-size: 12px;
    color: #999;
    text-align: right;
}

.reply-action {
    display: flex;
    justify-content: flex-end;
}

.empty-state {
    padding: 50px 0;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
}

.pagination {
    display: flex;
    justify-content: center;
    padding: 20px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .shop-evaluate-container {
        padding: 10px;
    }

    .product-info {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .product-image {
        margin-right: 0;
        margin-bottom: 15px;
    }

    .search-form {
        flex-wrap: wrap;
    }

    .comment-images {
        justify-content: center;
    }
}
</style>